
import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForwardToStationStructureSelectionDialogComponent } from './component/forward-to-station.component';
import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { TmcYardCommonModule } from '../../../../yard/common/common.module';
import { StructureSelectionModule } from '../../../../yard/common/structure-selection/structure-selection.module';

@NgModule({
  declarations: [
    ForwardToStationStructureSelectionDialogComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    TmcYardCommonModule,
    StructureSelectionModule
  ],
  exports: []
})
export class ForwardToStationModule { }
